import {
  UseMutationOptions,
  useMutation,
  useQuery,
} from "@tanstack/react-query"
import { PaginationState } from "@tanstack/react-table"
import type { Prisma } from "@tfg/db"

import { AdminResponses } from "@tfg/types/endpoints/admin"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"

export const useMagicLinkCount = () =>
  useQuery(["magicLink"], async () => {
    const res = await httpClient.get("/admin/magic-link/count")
    return res.data
  })

export const useMagicLinkLogsQuery = (
  fetchDataOptions: PaginationState,
  prismaSorting: Prisma.RefreshTokenOrderByWithRelationInput[] | []
) =>
  useQuery(
    ["magicLinkLogs", fetchDataOptions, prismaSorting],
    async () => {
      const res = await httpClient.get<AdminResponses.MagicLinkLogs[]>(
        "/admin/magic-link",
        {
          params: {
            fetchDataOptions,
            prismaSorting,
          },
        }
      )
      return res.data
    },
    { keepPreviousData: true }
  )

export const useDeleteMagicLinkMutation = (
  options?: UseMutationOptions<void, unknown, number>
) => {
  return useMutation({
    ...options,
    mutationFn: async (magicLinkId) => {
      return httpClient.delete(`/admin/magic-link/${magicLinkId}`)
    },
    onSuccess: (data, variables, context) => {
      options?.onSuccess?.(data, variables, context)
      queryClient.invalidateQueries(["magicLinkLogs"])
    },
  })
}
